import React, { createContext, useContext, useEffect, useState } from 'react'

export const DashboardContext: React.Context<DashboardProvider> = createContext<DashboardProvider>({
  isWide: false,
  setIsWide: async () => {
    return undefined
  },
})

export const useDashboard = (): DashboardProvider => {
  return useContext<DashboardProvider>(DashboardContext)
}

export interface DashboardProvider {
  isWide: boolean
  setIsWide: React.Dispatch<React.SetStateAction<boolean>>
}
export interface IProps {
  isWide?: boolean
}
export const useProvideDashboard = ({
  isWide: initialIsWide = false,
}: IProps): DashboardProvider => {
  const [isWide, setIsWide] = useState<boolean>(initialIsWide)

  useEffect(() => {
    setIsWide(initialIsWide)
  }, [initialIsWide])

  return {
    isWide,
    setIsWide,
  }
}
